import Swiper from "swiper/bundle";
import gsap from "gsap";
import { isIPhone, isIPad, isAndroid, isAndroidTab } from "@/src/front/common";

$(window).on("load", function () {
  heroSwiper();
  videoPlay();
  // gameList();
});

//==========
// gameヒーロースライダー
//==========
function heroSwiper() {
  const $heroSlider = $(".js-hero-swiper");
  if (!$heroSlider.length) return;

  // スライド複製（6枚未満なら複製して6枚にする）
  duplicateSlides($heroSlider);

  waitForImagesToLoad($heroSlider)
    .then(() => {
      const swiper = new Swiper($heroSlider[0], {
        init: false, // 手動で初期化するため
        lazy: { loadPrevNext: true },
        loop: true,
        watchSlidesProgress: true, // スライドの進行状況を監視
        observer: true, // DOM変更を監視
        observeParents: true, // 親要素のDOM変更を監視
        autoplay: {
          delay: 3300,
          disableOnInteraction: false,
        },
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          910: {
            slidesPerView: 3,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        effect: "creative",
        creativeEffect: {
          limitProgress: 4,
          prev: { scale: 0.9, translate: ["-45%", 0, 0], origin: "center" },
          next: { scale: 0.9, translate: ["45%", 0, 0], origin: "center" },
          next2: { scale: 0.7, translate: ["45%", 0, 0], origin: "center" },
          prev2: { scale: 0.7, translate: ["-45%", 0, 0], origin: "center" },
        },
      });

      // 初期 opacity 設定（thumbのみ）
      swiper.slides.forEach((slide) => {
        const thumb = slide.querySelector(".game-hero-slider-link__thumb");
        if (thumb) thumb.style.opacity = 1;
      });

      // ==============================
      // opacity 更新（GSAP アニメーション版）
      // ==============================
      function updateSlideOpacity() {
        swiper.slides.forEach((slide) => {
          const progress = slide.progress;
          const thumb = slide.querySelector(".game-hero-slider-link__thumb");
          const inner = slide.querySelector(".game-hero-slider-link__inner");
          if (thumb) {
            const maxDarken = 0.2; // 最大でどれくらい暗くするか（0 = 真っ黒）
            const brightness = 1 - Math.min(Math.abs(progress), 1) * maxDarken;
            gsap.to(thumb, {
              filter: `brightness(${brightness})`,
              duration: 0.5,
            });
          }
          if (inner) {
            const maxDarkenParent = 0;
            const absProgress = Math.abs(progress);
            const brightnessParent =
              absProgress < 1 ? 1 - absProgress * maxDarkenParent : 1;
            gsap.to(inner, {
              filter: `brightness(${brightnessParent})`,
              duration: 0.5,
            });
          }
        });
      }

      // prev2 / next2 クラス付与
      function updateSlideClasses() {
        swiper.slides.forEach((s) => $(s).removeClass("swiper-slide-prev2 swiper-slide-next2"));
        const total = swiper.slides.length;
        let active = swiper.activeIndex; // loop使用時はactiveIndexを使用
        const prev2Index = (active - 2 + total) % total;
        const next2Index = (active + 2) % total;
        $(swiper.slides[prev2Index]).addClass("swiper-slide-prev2");
        $(swiper.slides[next2Index]).addClass("swiper-slide-next2");
      }

      // 初期化完了後に呼ぶ（loopの準備が整ってから）
      swiper.on("init", () => {
        if ($heroSlider && $heroSlider.length) $heroSlider.removeClass("is-loading");
      });

      // 初期化をトリガー
      swiper.init();

      // 初期化後に確実に1枚目に移動してから処理
      setTimeout(() => {
        swiper.slideToLoop(0, 0);
        setTimeout(() => {
          swiper.loopFix();
          swiper.update();
          updateSlideClasses();
          updateSlideOpacity();
        }, 10);
      }, 10);

      // paginationクリック時にループを修正
      $(swiper.pagination.el).on("click", ".swiper-pagination-bullet", function () {
        // クリック後、スライド移動が完了してからループを修正
        setTimeout(() => {
          swiper.loopFix();
          swiper.update();
          updateSlideClasses();
          updateSlideOpacity();
        }, swiper.params.speed + 10);
      });

      // スワイプ / ボタン / ページネーション操作時も再計算
      swiper.on("slideChange slideChangeTransitionEnd", () => {
        updateSlideClasses();
        updateSlideOpacity();
      });

      // スライド hover で autoplay 停止
      $(".swiper-slide").hover(
        () => swiper.autoplay.stop(),
        () => swiper.autoplay.start(),
      );
    })
    .catch((error) => console.error("Error loading images:", error));

  // =================
  // 補助関数
  // =================
  function duplicateSlides($slider) {
    const $wrapper = $slider.find(".swiper-wrapper");
    const $slides = $slider.find(".js-hero-swiper-slide");
    const requiredSlides = 8;
    let slideCount = $slides.length;
    if (slideCount < requiredSlides) {
      let slidesAdded = 0;
      while (slidesAdded < requiredSlides - slideCount) {
        $slides.each(function () {
          if (slidesAdded >= requiredSlides - slideCount) return false;
          $wrapper.append($(this).clone());
          slidesAdded++;
        });
      }
    }
  }

  function waitForImagesToLoad($slider) {
    let $images = [];
    if (isIPhone || isAndroid) {
      $images = $slider.find("img.js-only-sp");
    } else if (isIPad || isAndroidTab) {
      $images = $slider.find("img.js-only-tb");
    } else {
      $images = $slider.find("img.js-only-pc");
    }
    if ($images.length === 0) return Promise.resolve();

    let loadedCount = 0;
    return new Promise((resolve) => {
      $images.each(function () {
        this.removeAttribute("loading");

        if (this.complete) {
          loadedCount++;
          if (loadedCount === $images.length) resolve();
        } else {
          $(this).on("load error", function () {
            loadedCount++;
            if (loadedCount === $images.length) resolve();
          });
        }
      });
    });
  }

  //==========
  // click時、アクティブスライドでなければイベントキャンセルする
  //==========
  $(".js-hero-swiper-slide").on("click", function (e) {
    $(this).hasClass("swiper-slide-active") != true && e.preventDefault();
  });
}

// 高さ調整
// function updateSwiperHeight($slider) {
//   // let maxHeight = 0;
//   // $slider.find(".swiper-slide").each(function () {
//   //   const h = $(this).outerHeight(true);
//   //   if (h > maxHeight) maxHeight = h;
//   // });
//   // if (maxHeight) $slider.height(maxHeight);
// }

//==========
// 動画再生
//==========
function videoPlay() {
  // SPデバイスまたはタブレットの場合は動画再生を無効にする
  if (typeof isIPhone !== "undefined" && (isIPhone || isAndroid || isIPad || isAndroidTab)) {
    return;
  }

  /**
   * 動画のディレイ再生を管理するクラス
   */
  class DelayedVideoPlayerQueue {
    constructor() {
      // { videoElement: data{ queueId, videoBoxElement, fadeTime } }
      this.queue = [];

      // 単位はms (1000ms = 1秒)
      this.delayDuration = 700; // 再生までの遅延時間
    }

    add(videoElement) {
      // 既にキューに登録されている場合は何もしない
      const isInQueued = this.queue.some(queue => queue.videoElement === videoElement);
      if (isInQueued) return;

      // キューに追加
      this.queue.push({ videoElement, queueId: setTimeout(this._play.bind(this, videoElement), this.delayDuration) });

      // console.log(`QueueAdd: ${videoElement}`);
    }

    remove(videoElement) {
      // キューからエントリを削除して、削除したエントリを格納
      const foundQueueIndex = this.queue.findIndex(queue => queue.videoElement === videoElement);
      if (foundQueueIndex === -1) return;

      // キューから削除
      clearTimeout(this.queue.splice(foundQueueIndex, 1)[0].queueId);

      // 動画状態をリセット
      videoElement.style.display = "none";
      videoElement.pause();
      videoElement.currentTime = 0;

      // console.log(`QueueRemove: ${videoElement}`);
    }

    _play(videoElement) {
      videoElement.play();
      videoElement.style.display = "block";

      // console.log(`QueuePlay: ${videoElement}`);
    }
  }
  const queue = new DelayedVideoPlayerQueue();

  const $parent = $(".js-video-parent");
  $parent.off("mouseenter mouseleave");
  $parent.hover(
    function () {
      const $target = $(this).find(".js-video");

      if ($target.length) {
        queue.add($target.get(0));
      }
    },
    function () {
      const $target = $(this).find(".js-video");

      if ($target.length) {
        queue.remove($target.get(0));
      }
    },
  );
}

//==========
// ゲームリスト 並び替え
//==========
// function gameList() {
//   if ($("#js-game-list").length) {
//     $("#js-game-list").mixItUp();
//   }
// }
